export const initialState = {
    
};

export const reducer = (state, action) => {
    switch(action.type) {
      default:
        return state;
    };
};